import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import shallowequal from "shallowequal";
import Filters from "collections/filters";
import { themeOptions } from "styles/theme";
import { IconButton, List, ListSubheader } from "@material-ui/core";
import { updateFiltersCache } from "actions/filters";
import SelectFilter from "./select";
import DateFilter from "./date";
import NumberFilter from "./number";
import RadioFilter from "./radio";
import InventoryFilter from "./custom/inventory";
import ImageFilter from "./custom/image-filter";
import { AutoCompleteFilter } from "./auto-complete";
import Globalize from "globalize";
import Immutable from "immutable";
import Toggle from "material-ui/Toggle";
import Close from "components/icons/close";
import { Form } from "formsy-react";
import { triggerResize } from "lib/helpers";
import CircularProgress from "material-ui/CircularProgress";
import { DATATEST } from "constants/integration";
import { isPhablet } from "constants/media";
import me from "models/me";
import { SelectedFiltersOptions } from "components/filters/selected-filters-options";
import { baseOrderIntentsFields } from "constants/order-intents";
import moment from "moment";
import { isCustomizationsPerCompanyEnabled } from "components/customization-modal/helpers";

/** @augments {Component<any, any>} */
class FilterSection extends Component {
    static contextTypes = {
        me: PropTypes.object.isRequired,
    };

    static propTypes = {
        onFilterChange: PropTypes.func.isRequired,
        onInventoryFilterChange: PropTypes.func,
        activeFiltersValues: PropTypes.instanceOf(Immutable.Map),
        resource: PropTypes.oneOf([
            "order",
            "item",
            "gallery",
            "company",
            "campaigns",
            "smart-group",
            "linesheets",
            "custom-list",
            "global-search",
            "connection-requests",
            "contacts",
            "inventory",
            "cancelled-styles",
            "cancelled-styles-orders",
            "generic", // used to pass custom filters without fetching anything from backend
            "order-intents",
        ]).isRequired,
        useChips: PropTypes.bool,
        filtersDisabled: PropTypes.bool,
        title: PropTypes.string,
        clearAll: PropTypes.bool,
        filterInclusions: PropTypes.array,
        filterExclusions: PropTypes.array,
        onFocus: PropTypes.func,
        onDismiss: PropTypes.func,
        scope: PropTypes.any,
        companyId: PropTypes.string,
        router: PropTypes.any,
        cache: PropTypes.any.isRequired,
        updateFiltersCache: PropTypes.func.isRequired,
        advancedSearchKey: PropTypes.object,
        hiddenFilters: PropTypes.arrayOf(PropTypes.string),
        viewport: PropTypes.string,
        catalog: PropTypes.object,
        refreshingFilters: PropTypes.bool,
        onFiltersRefreshComplete: PropTypes.func,
        containerClassName: PropTypes.string,
        omitInclusions: PropTypes.bool,
        b2BRetailerConnectionRequestEnhancementsPhase1: PropTypes.bool,
        useAutocompleteURLQuery: PropTypes.bool,
        assortmentsOrderIntentNu57496: PropTypes.bool,
    };

    static defaultProps = {
        filtersDisabled: false,
        clearAll: true,
        title: null,
        containerClassName: "",
    };

    styles = {
        list: {
            position: "relative",
            backgroundColor: "transparent",
            WebkitTransform: "translate3d(0, 0, 0)",
        },
        subheader: {
            color: themeOptions.palette.darkerGrey,
            fontFamily: "Lato, sans-serif",
            fontSize: "14px",
            fontWeight: 600,
            lineHeight: "48px",
            paddingLeft: 8,
        },
        close: {
            position: "absolute",
            top: "8px",
            right: "8px",
            height: "32px",
            width: "32px",
            padding: "0px 6px",
            transition: "all .2s ease-in-out",
            display: "none",
            opacity: 0,
        },
        showClose: {
            display: "inline-block",
        },
        closeShow: {
            opacity: 1,
        },
        closeIcon: {
            height: "16px",
            width: "16px",
        },
        loading: {
            display: "flex",
            justifyContent: "center",
            marginTop: "40px",
        },
        toggle: {
            display: "inline-block",
            width: "150px",
            margin: "10px",
        },
    };

    constructor(props) {
        super(props);
        const filters = props.filterOptions || new Filters();
        filters.type = props.resource === "gallery" ? "item" : props.resource;
        filters.catalog = props.catalog?.id;

        this.state = {
            filters,
            cacheFilters: !!_.get(props.cache, [props.scope.brand._id, props.resource]),
            storeEnabledResources: ["order"],
            fetchSuccessCount: 0,
            usingAdvancedSearch: false,
            isDynamicFilter: false,
        };

        this.handleClear = this.handleClear.bind(this);
    }

    UNSAFE_componentWillMount() {
        this._mounted = true;

        const { props } = this;
        const { filters } = this.state;

        if (props.filterOptions) {
            return;
        }

        filters.on("sync", this.handleOnFilterLoad, this);
        if (["linesheets", "campaigns", "connection-requests"].includes(props.resource)) {
            this.handleOnFilterLoad();

            return;
        }

        const isCustomizationEnabled = isCustomizationsPerCompanyEnabled(props.scope);
        const data = props.catalog?.id
            ? generateEntriesQueryParams(props)
            : {
                  __fields: "__name,__buyers,_id",
                  __company: !isCustomizationEnabled ? undefined : props.companyId,
              };

        filters.fetch({
            data,
            success: (_model, data) => {
                if (this._mounted) {
                    this.setState({ isDynamicFilter: data?.dynamic_filter });
                }
            },
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { props, state } = this;
        const { scope } = props;
        const { filters } = state;
        const isNewBrand = scope?.brand?._id !== nextProps.scope?.brand?._id;
        const isCustomizationEnabled = isCustomizationsPerCompanyEnabled(scope);
        const isNewCompany = props?.companyId !== nextProps.companyId && isCustomizationEnabled;
        if ((isNewBrand || isNewCompany) && nextProps.resource !== "generic") {
            filters.reset();
            filters.fetch(
                !isCustomizationEnabled
                    ? undefined
                    : {
                          data: {
                              __company: nextProps.companyId,
                          },
                      },
            );
        }

        const { router } = nextProps;
        if (!router) {
            return;
        }

        const advancedSearch = router.location.query.advanced_search === "true" && !this.state.usingAdvancedSearch;
        this.setState({ usingAdvancedSearch: advancedSearch });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.fetchSuccessCount !== this.state.fetchSuccessCount) {
            triggerResize(); // hack for modal to resize
        }

        if (
            this.props.catalog?.id &&
            this.state.isDynamicFilter &&
            (this.props.activeFiltersValues !== prevProps.activeFiltersValues ||
                (this.props.refreshingFilters && this.props.refreshingFilters !== prevProps.refreshingFilters))
        ) {
            this.state.filters.reset();
            this.state.filters.fetch({
                data: generateEntriesQueryParams(this.props),
            });
            this.props.onFiltersRefreshComplete?.();
        }
    }

    componentWillUnmount() {
        this._mounted = false;
        if (this.state.filters.off) {
            this.state.filters.off("sync", this.handleOnFilterLoad, this);
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            nextProps.activeFiltersValues !== this.props.activeFiltersValues ||
            nextState.fetchSuccessCount !== this.state.fetchSuccessCount ||
            !shallowequal(this.state, nextState) ||
            nextProps.refreshingFilters !== this.props.refreshingFilters
        );
    }

    handleOnFilterLoad() {
        const { me } = this.context;
        const { resource, filterInclusions, filterExclusions, scope, catalog } = this.props;

        // HACK FOR VISIBILITY
        if (me.hasPermission("view_disabled_items") && resource === "gallery") {
            this.state.filters.add({
                __key: "__active",
                __type: "radio",
                __name: Globalize.formatMessage("Visibility"),
                __data: [
                    {
                        __label: Globalize.formatMessage("Active"),
                        __value: "active",
                        __default: true,
                    },
                    {
                        __label: Globalize.formatMessage("Inactive"),
                        __value: "inactive",
                    },
                    {
                        __label: Globalize.formatMessage("All"),
                        __value: "all",
                    },
                ],
            });
        }

        // Had to change the naming here to handle the "enforce_delivery_window" filter on catalog pages
        if (me.hasPermission("view_disabled_items") && resource === "item") {
            this.state.filters.add({
                __key: "__active",
                __type: "radio",
                __name: Globalize.formatMessage("Status"),
                __data: [
                    {
                        __label: Globalize.formatMessage("Active"),
                        __value: "active",
                        __default: true,
                    },
                    {
                        __label: Globalize.formatMessage("Inactive"),
                        __value: "inactive",
                    },
                    {
                        __label: Globalize.formatMessage("All"),
                        __value: "all",
                    },
                ],
            });
        }

        if (resource === "item") {
            if (scope && scope.brand.hasPreference("gallery_inventory_qty_filter")) {
                const targetIndex = this.state.filters.indexOf(this.state.filters.get("__inventory"));
                this.state.filters.add(
                    {
                        __key: "inventory",
                        __condition_key: "__inventory_rollup_is",
                        __condition_value_key: "__inventory_rollup_qty",
                        __type: "inventory",
                        __default_open: false,
                        __name: Globalize.formatMessage("Inventory"),
                        __data: [
                            {
                                __label: Globalize.formatMessage("Not Selected"),
                                __value: "",
                                __default: true,
                            },
                            {
                                __label: Globalize.formatMessage("Greater Than"),
                                __value: "greater_than",
                            },
                            {
                                __label: Globalize.formatMessage("Less Than"),
                                __value: "less_than",
                            },
                            {
                                __label: Globalize.formatMessage("Equal To"),
                                __value: "equal_to",
                            },
                        ],
                    },
                    {
                        at: targetIndex + 1,
                    },
                );
            }

            const deliveriesFilter = _.find(this.state.filters.models, { __key: "__available_from" })?.toJSON();
            if (catalog && deliveriesFilter) {
                const mins = _.compact([catalog.delivery_window_start, deliveriesFilter.__min_date]);
                const maxs = _.compact([catalog.delivery_window_end, deliveriesFilter.__max_date]);
                if (!_.isEmpty(mins)) {
                    deliveriesFilter.__min_date = moment.max(mins.map((x) => moment.utc(x)));
                }
                if (!_.isEmpty(maxs)) {
                    deliveriesFilter.__max_date = moment.min(maxs.map((x) => moment.utc(x)));
                }
                this.state.filters.add(deliveriesFilter, { merge: true });
            }
        }

        // LINESHEETS VISIBILITY
        if (resource === "linesheets") {
            this.state.filters.add({
                __key: "visibility",
                __type: "radio",
                __default_open: true,
                __name: Globalize.formatMessage("Status"),
                __data: [
                    {
                        __label: Globalize.formatMessage("All"),
                        __value: "all",
                        __default: true,
                    },
                    {
                        __label: Globalize.formatMessage("Active"),
                        __value: "active",
                    },
                    {
                        __label: Globalize.formatMessage("Inactive"),
                        __value: "inactive",
                    },
                ],
            });

            if (me.hasPermission("edit_linesheet")) {
                this.state.filters.add({
                    __key: "enforce_delivery_windows",
                    __type: "radio",
                    __default_open: true,
                    __name: Globalize.formatMessage("Visibility"),
                    __data: [
                        {
                            __label: Globalize.formatMessage("All Linesheets", {
                                Linesheets:
                                    scope && scope.brand.hasPreference("linesheets_are_catalogs")
                                        ? Globalize.formatMessage("Catalogs")
                                        : Globalize.formatMessage("Linesheets"),
                            }),
                            __value: "all",
                        },
                        {
                            __label: Globalize.formatMessage("Valid Linesheets", {
                                Linesheets:
                                    scope && scope.brand.hasPreference("linesheets_are_catalogs")
                                        ? Globalize.formatMessage("Catalogs")
                                        : Globalize.formatMessage("Linesheets"),
                            }),
                            __value: "include",
                            __default: true,
                        },
                        {
                            __label: Globalize.formatMessage("Expired Linesheets", {
                                Linesheets:
                                    scope && scope.brand.hasPreference("linesheets_are_catalogs")
                                        ? Globalize.formatMessage("Catalogs")
                                        : Globalize.formatMessage("Linesheets"),
                            }),
                            __value: "exclude",
                        },
                    ],
                });
            }
        }

        if (resource === "custom-list") {
            if (["buyer", "brand"].includes(me.account_type)) {
                this.state.filters.add({
                    __key: "shared",
                    __type: "radio",
                    __default_open: true,
                    __name: Globalize.formatMessage("List Owner"),
                    __data: [
                        {
                            __label: Globalize.formatMessage("All Lists"),
                            __value: "all",
                            __default: true,
                        },
                        {
                            __label: Globalize.formatMessage("My Lists"),
                            __value: "false",
                        },
                        {
                            __label: Globalize.formatMessage("Lists shared with me"),
                            __value: "true",
                        },
                    ],
                });
            }

            this.state.filters.add({
                __key: "enforce_delivery_windows",
                __type: "radio",
                __default_open: true,
                __name: Globalize.formatMessage("Visibility"),
                __data: [
                    {
                        __label: Globalize.formatMessage("All Lists"),
                        __value: "all",
                    },
                    {
                        __label: Globalize.formatMessage("Valid Lists"),
                        __value: "include",
                        __default: true,
                    },
                    {
                        __label: Globalize.formatMessage("Expired Lists"),
                        __value: "exclude",
                    },
                ],
            });
        }

        if (resource === "campaigns") {
            this.state.filters.add({
                __key: "status",
                __type: "radio",
                __default_open: true,
                __name: Globalize.formatMessage("Status"),
                __data: [
                    {
                        __label: Globalize.formatMessage("Sent"),
                        __value: "sent",
                        __default: true,
                    },
                    {
                        __label: Globalize.formatMessage("Drafts"),
                        __value: "not sent",
                    },
                ],
            });

            this.state.filters.add({
                __key: "active",
                __type: "radio",
                __default_open: false,
                __name: Globalize.formatMessage("Archived"),
                __data: [
                    {
                        __label: Globalize.formatMessage("Unarchived"),
                        __value: "true",
                        __default: true,
                    },
                    {
                        __label: Globalize.formatMessage("Archived"),
                        __value: "false",
                    },
                ],
            });
        }

        if (resource === "connection-requests") {
            const defaultFilters = [
                {
                    __name: Globalize.formatMessage("Pending"),
                    __value: "pending",
                    __default: true,
                },
                {
                    __name: Globalize.formatMessage("Approved"),
                    __value: "approved",
                },
                {
                    __name: Globalize.formatMessage("Denied"),
                    __value: "denied",
                },
                /* {
                    __name: Globalize.formatMessage("Blocked"),
                    __value: "blocked",
                }, */
            ];

            const inReviewFilter = {
                __name: Globalize.formatMessage("In review"),
                __value: "review",
            };

            const [pendingFilter, ...rest] = defaultFilters;
            const filters = this.props.b2BRetailerConnectionRequestEnhancementsPhase1
                ? [pendingFilter, inReviewFilter, ...rest]
                : [...defaultFilters];

            this.state.filters.add({
                __key: "status",
                __type: "standard",
                __default_open: true,
                __name: Globalize.formatMessage("Status"),
                __data: filters,
            });
            this.state.filters.add({
                __key: "archived",
                __type: "radio",
                __default_open: false,
                __name: Globalize.formatMessage("Archived"),
                __data: [
                    {
                        __label: Globalize.formatMessage("Not archived"),
                        __value: "",
                        __default: true,
                    },
                    {
                        __label: Globalize.formatMessage("Archived"),
                        __value: "true",
                    },
                    {
                        __label: Globalize._formatMessage("All"),
                        __value: "all",
                    },
                ],
            });
            this.state.filters.add({
                __key: "created_on",
                __min_key: "created_on_gte",
                __max_key: "created_on_lte",
                __type: "date",
                __default_open: false,
                __name: Globalize.formatMessage("Request Date"),
            });
        }

        if (resource === "order-intents") {
            this.state.filters.add({
                __key: "created_on",
                __min_key: "created_on_gte",
                __max_key: "created_on_lte",
                __type: "date",
                __name: Globalize.formatMessage("Date Created"),
            });

            this.state.filters.add({
                __key: "date_modified",
                __min_key: "date_modified_gte",
                __max_key: "date_modified_lte",
                __type: "date",
                __name: Globalize.formatMessage("Last Modified"),
            });

            this.state.filters.add({
                __key: "retailer_id",
                __type: "autocomplete",
                __subtype: "string",
                __name: Globalize.formatMessage("Merchant"),
                __convert_to_id: true,
                __uri_key: "__match",
                __uri: "/api/v3.0/order-intents/retailers",
            });

            this.state.filters.add({
                __key: "buyer_id",
                __type: "autocomplete",
                __subtype: "string",
                __name: Globalize.formatMessage("Buyer"),
                __convert_to_id: true,
                __uri_key: "__match",
                __uri: "/api/v3.0/order-intents/buyers",
            });

            this.state.filters.add({
                __key: "ship_start",
                __min_key: "ship_start_gte",
                __max_key: "ship_start_lte",
                __type: "date",
                __name: Globalize.formatMessage("Ship Start Date"),
            });

            this.state.filters.add({
                __key: "ship_end_date",
                __min_key: "ship_end_gte",
                __max_key: "ship_end_lte",
                __type: "date",
                __name: Globalize.formatMessage("Ship End Date"),
            });

            this.state.filters.add({
                __key: "total_cost",
                __type: "number",
                __min_key: "total_cost_gte",
                __max_key: "total_cost_lte",
                __name: Globalize.formatMessage("Total $"),
            });
        }

        if (filterInclusions && filterInclusions.length) {
            this.state.filters.add(filterInclusions);
        }

        if (filterExclusions && filterExclusions.length) {
            this.state.filters.remove(filterExclusions);
        }

        this.setState({
            fetchSuccessCount: this.state.fetchSuccessCount + 1,
        });
        this.forceUpdate();
    }

    handleInventoryFilterChange = (activeFiltersValues) => {
        this.props.onInventoryFilterChange(activeFiltersValues);
        this.updateCacheFiltersAndTrackAction(activeFiltersValues);
    };

    handleFilterChange = (activeFiltersValues) => {
        this.props.onFilterChange(activeFiltersValues);
        this.updateCacheFiltersAndTrackAction(activeFiltersValues);
    };

    updateCacheFiltersAndTrackAction(activeFiltersValues) {
        const { me } = this.context;
        const { updateFiltersCache, resource, scope } = this.props;
        if (this.state.cacheFilters) {
            updateFiltersCache(scope.brand._id, resource, activeFiltersValues);
        }

        let resourceTitle;
        switch (resource) {
            case "item":
            case "gallery":
                resourceTitle = "Items";
                break;
            case "order":
                resourceTitle = "Orders";
                break;
            case "company":
                resourceTitle = "Companies";
                break;
            case "linesheets":
                resourceTitle = "Linesheets";
                break;
            case "campaigns":
                resourceTitle = "Campaigns";
                break;
            case "order-intents":
                resourceTitle = "OrderIntents";
                break;
            default:
                resourceTitle = "Generic";
        }

        me.trackAction(`${resourceTitle} Filter`, activeFiltersValues.toJS());
    }

    checkOrdersPageActiveFilters() {
        const activeFiltersJS = this.props.activeFiltersValues.toJS();

        return Object.keys(activeFiltersJS).reduce(
            (acc, key) => {
                const target = baseOrderIntentsFields.includes(key) ? "orderIntentsFilters" : "ordersFilters";
                acc[target][key] = activeFiltersJS[key];
                return acc;
            },
            { ordersFilters: {}, orderIntentsFilters: {} },
        );
    }

    handleClear() {
        const { me } = this.context;
        const {
            onFilterChange,
            updateFiltersCache,
            resource,
            activeFiltersValues,
            scope,
            assortmentsOrderIntentNu57496,
        } = this.props;

        const __search = activeFiltersValues.get("__search");
        let newFilters = __search ? Immutable.Map({ __search }) : Immutable.Map();

        if (
            (assortmentsOrderIntentNu57496 || this.props.scope.brand.hasModuleEnabled("assortment_order_intents")) &&
            !me.isBuyer() &&
            (resource === "order" || resource === "order-intents")
        ) {
            const filtersResult = this.checkOrdersPageActiveFilters();
            newFilters = Immutable.fromJS({
                ...(__search ? { __search } : {}),
                ...(resource === "order-intents" ? filtersResult.ordersFilters : {}),
                ...(resource === "order" ? filtersResult.orderIntentsFilters : {}),
            });
        }

        onFilterChange(newFilters);

        if (this.state.cacheFilters) {
            updateFiltersCache(scope.brand._id, resource, newFilters);
        }

        let resourceTitle;
        switch (resource) {
            case "item":
            case "gallery":
                resourceTitle = "Items";
                break;
            case "order":
                resourceTitle = "Orders";
                break;
            case "order-intents":
                resourceTitle = "OrderIntents";
                break;
            default:
                resourceTitle = "Generic";
        }

        me.trackAction(`${resourceTitle} Filter Cleared`);
    }

    render() {
        const {
            activeFiltersValues,
            filtersDisabled,
            title,
            clearAll,
            onFocus,
            onDismiss,
            hiddenFilters = [],
            resource,
            useChips,
            containerClassName,
            viewport,
            useAutocompleteURLQuery,
            assortmentsOrderIntentNu57496,
        } = this.props;
        const { filters, cacheFilters } = this.state;
        const { me } = this.context;

        let hasActiveFilters = activeFiltersValues && activeFiltersValues.size > 0;
        if (hasActiveFilters && activeFiltersValues.size === 1 && activeFiltersValues.get("__search") !== undefined) {
            hasActiveFilters = false;
        }
        if (
            hasActiveFilters &&
            assortmentsOrderIntentNu57496 &&
            !me.isBuyer() &&
            (resource === "order" || resource === "order-intents")
        ) {
            const filtersResult = this.checkOrdersPageActiveFilters();
            hasActiveFilters =
                Object.keys(resource === "order" ? filtersResult.ordersFilters : filtersResult.orderIntentsFilters)
                    .length > 0;
        }

        const styles = this.styles;

        if (!activeFiltersValues) {
            return null;
        }

        if (!filters.length) {
            return (
                <div style={styles.loading}>
                    <CircularProgress />
                </div>
            );
        }

        const filterComponents = filters
            .filter((filter) => !hiddenFilters.includes(filter.__key))
            .map((filter, i) => {
                const fieldIsAdvancedSearchField =
                    this.props.router && this.props.router.location.query.search_field === filter.__key;
                const isAdvancedSearchSelection = this.state.usingAdvancedSearch && fieldIsAdvancedSearchField;
                const attrs = {
                    key: filter.__key || `${filter.__min_key}-${filter.__max_key}`,
                    filter,
                    activeFiltersValues,
                    onChange: this.handleFilterChange,
                    lastFilter: filters.length - 1 === i,
                    filtersDisabled: filtersDisabled || isAdvancedSearchSelection,
                    onFocus: onFocus,
                    onDismiss: onDismiss,
                };

                // NU-55062 Card Associated --> Payment Associated
                if (filter.__key === "has_card_on_file") {
                    filter.__name = "Payment Associated";
                }

                switch (filter.__type) {
                    case "standard":
                        return <SelectFilter {...attrs} />;
                    case "autocomplete":
                        return <AutoCompleteFilter {...attrs} useURLQuery={useAutocompleteURLQuery} />;
                    case "date":
                        return <DateFilter {...attrs} />;
                    case "radio":
                        return <RadioFilter {...attrs} />;
                    case "inventory":
                        return <InventoryFilter {...attrs} onChange={this.handleInventoryFilterChange} />;
                    case "image":
                        return <ImageFilter {...attrs} />;
                    case "number":
                        return <NumberFilter {...attrs} />;
                    default:
                        return null;
                }
            });

        const showClearButton = !filtersDisabled && !this.state.usingAdvancedSearch;
        const subheader = (
            <ListSubheader style={styles.subheader} disableSticky={true}>
                {title || Globalize.formatMessage("Filters")}
                <IconButton
                    data-test={DATATEST.ASSORTMENTS.CLEAR_FILTERS}
                    style={Object.assign(
                        {},
                        styles.close,
                        clearAll && styles.showClose,
                        hasActiveFilters && showClearButton && styles.closeShow,
                    )}
                    onClick={this.handleClear}
                >
                    <Close style={styles.closeIcon} />
                </IconButton>
            </ListSubheader>
        );

        return (
            <List style={styles.list} className={`filterList ${containerClassName}`} subheader={subheader}>
                {useChips && (
                    <SelectedFiltersOptions
                        activeFiltersValues={activeFiltersValues}
                        onDelete={this.handleFilterChange}
                    />
                )}
                <Form data-test="filters-container">{filterComponents}</Form>
                {!isPhablet(viewport) && this.state.storeEnabledResources.includes(resource) && (
                    <Toggle
                        label={Globalize.formatMessage("Save filters")}
                        toggled={cacheFilters}
                        onToggle={this.handleSaveFiltersChange}
                        labelPosition="right"
                        style={styles.toggle}
                        data-test={DATATEST.ORDERS.SAVE_FILTERS_TOGGLE}
                    />
                )}
            </List>
        );
    }

    handleSaveFiltersChange = (event, cacheFilters) => {
        const { activeFiltersValues, resource, updateFiltersCache, scope } = this.props;
        this.setState({ cacheFilters });
        updateFiltersCache(scope.brand._id, resource, cacheFilters ? activeFiltersValues : null);
    };
}

const generateEntriesQueryParams = (props) => {
    const { activeFiltersValues, scope, omitInclusions, filterInclusions } = props;

    const query = {
        __active_pricesheet: me._activePriceTemplate,
        __fields: "__all",
        __limit: 50,
        __archived: false,
        __view_disabled: false,
    };

    if (scope.viewAs) {
        query.__company = scope.viewAs._id;
    }

    if (scope.viewAsGuest) {
        query.__guest = "true";
    }

    if (activeFiltersValues.size > 0) {
        const filters = (
            omitInclusions && filterInclusions
                ? filterInclusions.reduce((acc, { __key }) => acc.remove(__key), activeFiltersValues)
                : activeFiltersValues
        ).toJS();

        if (filters.__active) {
            switch (filters.__active) {
                case "active":
                    filters.__active = true;
                    break;
                case "inactive":
                    filters.__view_disabled = true;
                    filters.__active = false;
                    break;
                default:
                    filters.__view_disabled = true;
                    delete filters.__active;
            }
        }
        Object.assign(query, filters);
    }
    return query;
};

const mapStateToProps = (state) => {
    const { scope } = state;

    return {
        cache: state.filters.cache,
        scope: state.scope,
        companyId: (scope.company ?? scope.viewAs)?._id,
        viewport: state.app.viewport,
        b2BRetailerConnectionRequestEnhancementsPhase1:
            state.ldFlags.b2BRetailerConnectionRequestEnhancementsPhase1 || false,
        assortmentsOrderIntentNu57496: state.ldFlags.assortmentsOrderIntentNu57496 || false,
    };
};

const mapDispatchToProps = (dispatch) => ({
    updateFiltersCache: (brandId, key, filters) => dispatch(updateFiltersCache(brandId, key, filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FilterSection);
